import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation, MArea, AreaEnum } from '@sailor/i18n-web'
import { getUestionnaireUrl } from './api'
import Icon from '@roo/roo/Icon'
import { getHost, getLoginShopid, jumpTo, getUniversityUrl, getCSUrl, getRegion, hasBRbacPermission, hasPermissionBatch, isProd } from '@RootCommon/utils'
import { getSafeArea } from '@RootCommon/utils/h5PC'
import useDevice from '@/common/hooks/useDevice'
import { owlAddJsError, owlReportMetrics } from '@RootCommon/utils/owl'
import { lxPV, lxMC } from '@/common/utils/lx'
import { LvPoint } from './constant'
import ShopInfo from './components/ShopInfo'
import customer from '../../common/assets/images/more/customer_icon.png'
import download from '../../common/assets/images/more/download_icon.png'
import golden from '../../common/assets/images/more/golden_icon.png'
import restaurant from '../../common/assets/images/more/restaurant_icon.png'
import ConfigProvider from '@roo/roo/ConfigProvider'
import { getDirection, isRTL, buildURL } from '@RootCommon/utils'
import '@/tailwind.css'
// import { EntryInMoreTab } from '@wmfe/sailor-ad-entry'
import EntryInMoreTab from './components/EntryInMoreTab'
import regionPermission from '@RootCommon/constants/regionPermission.json'
import { getIsEUIDC } from '@sailor/compass'

import styles from './style.js'

const halfWidthCard = ({
  isShow,
  onClickHandler,
  iconName,
  content,
}) => (isShow
  ? <div
    className={`${styles.halfWidthCard} flex-1 rounded-lg bg-white py-[18px] pl-3 pr-[14px] flex items-center justify-between`}
    onClick={onClickHandler || (() => {})}
    style={{
      minWidth: '45%',
      maxWidth: 'calc(50% - 12px)',
      margin: 6,
    }}
  >
    <div className="text-base leading-5">
      <div>{content}</div>
    </div>
    <img width={34} height={34} src={iconName} />
  </div> : null)

const fullWidthArrowCard = ({
  isShow,
  onClickHandler,
  iconName,
  content,
}) => (isShow
  ? <div
    className="text-base leading-[60px] cursor-pointer flex justify-between items-center"
    onClick={onClickHandler || (() => {})}
  >
    <div className="flex items-center">
      <Icon name={iconName} className={`${isRTL() ? 'ml-2' : 'mr-2'} text-xl`} />
      {content}
    </div>
    <Icon name="icon-jiantou-xianxing02" className={isRTL() ? 'rotate-180' : ''} />
  </div> : null)

let firstRender = true
function More () {
  useEffect(() => {
    if (firstRender) {
      try {
        // eslint-disable-next-line
        owl && owl('addPoint', { position: 23 }) // 以页面首次渲染作为首次有内容绘制时间
      } catch (e) {
        console.log(e)
      }
    }
    firstRender = false
  }, [])

  const [top, setTop] = useState(44)
  const { isH5 } = useDevice()

  const { t } = useTranslation('business_status')
  const { t: tnb } = useTranslation('Native_BasicServices')
  const isHealthShow = useMemo(() => {
    const region = getRegion()
    const currentPermission = regionPermission[region] || []
    console.log('isHealthShow|region', region)
    console.log('isHealthShow|currentPermission', currentPermission)
    return currentPermission.includes('health_score') && hasBRbacPermission('PARTNER_BIZ_DATA_HEALTHY')
  }, [])
  const showMerchantMall = useMemo(() => !['BR', 'MG', ...MArea.getRegionsByArea(AreaEnum.GCC)].includes(getRegion()) && hasBRbacPermission('PARTNER_MERCHANT_MALL'), [])
  const showHotLine = useMemo(() =>
    // 除GCC新国外，其余地区都要展示
    !['QA', 'OM', 'AE', 'BH', 'KW'].includes('QA') && hasBRbacPermission('PARTNER_HELP_PHONE')
  , [])
  const handleToShopSetting = () => {
    isH5 && lxMC(LvPoint.bid.MoreShopSettings, LvPoint.cid.Index_More)
    jumpTo(`${getHost()}/web/app/shop#/shopSettings`)
  }

  const handleToCustomerReview = () => {
    isH5 && lxMC(LvPoint.bid.MoreCustomerReview, LvPoint.cid.Index_More)
    jumpTo(`${getHost()}/web/app/shop#/evaluate`, { withTitleBar: true })
  }

  const handleToRestaurant = () => {
    isH5 && lxMC(LvPoint.bid.MoreRestaurant, LvPoint.cid.Index_More)
    let realUrl = buildURL('sailorpartner://keeta.com/machpro', { mach_bundle_name: 'mach_pro_sailor_b_app_shop_health_score' })
    realUrl = buildURL(realUrl, { type: 0 })
    if (!KNB) return
    KNB?.openPage({
      url: realUrl,
      query: { notitlebar: 1, future: 2 },
      fail (e) {
        console.log(e)
        owlAddJsError('partner 更多页跳转健康度异常', { e })
      },
      success (e) {},
    })
  }
  const handleToDownload = () => {
    isH5 && lxMC(LvPoint.bid.MoreRestaurant, LvPoint.cid.Index_More)
    jumpTo(`${getHost()}/web/app/bizdata/#/dataDownload`)
  }

  const handleToUniversity = () => {
    isH5 && lxMC(LvPoint.bid.University, LvPoint.cid.Index_More)
    jumpTo(decodeURIComponent(getUniversityUrl()), { withTitleBar: true })
  }

  const handleToHelpCenter = () => {
    isH5 && lxMC(LvPoint.bid.MoreHelpCenter, LvPoint.cid.Index_More)
    const _url = getCSUrl(false, false)
    console.log('getCSUrl:', _url)
    jumpTo(_url, { withTitleBar: true })
  }

  const handleToDeliveryMall = async () => {
    isH5 && lxMC(LvPoint.bid.MoreDeliveryMall, LvPoint.cid.Index_More)
    getUestionnaireUrl(getLoginShopid()).then((url: string) => jumpTo(url, url.includes('notitlebar=1') ? { withTitleBar: false } : { withTitleBar: true }))
  }

  const handleToHotline = () => {
    isH5 && lxMC(LvPoint.bid.Hotline, LvPoint.cid.Index_More)
    const isGCCAndBR = ['BR', 'MG', ...MArea.getRegionsByArea(AreaEnum.GCC)].includes(getRegion())
    const phoneList = {
      QA: '44463653',
      SA: '0115079037',
      HK: '21756833',
    }
    jumpTo(`sailorpartner://keeta.com/machproalert?bundle_name=mach_pro_sailor_partner_call_phone&data=${encodeURIComponent(JSON.stringify({
      phone: phoneList[getRegion()] || '21756833', service_time: isGCCAndBR ? t('bappKSA_service_hour') : t('bappB_H_A_F_8_T_2'),
    }))}`)
  }

  useEffect(() => {
    const { top } = getSafeArea()
    setTop(top || 44)
    KNB && KNB.setBouncesEnabled({ enabled: 0 })
    isH5 && lxPV(LvPoint.cid.Index_More)
  }, [])

  return (<ConfigProvider config={{ direction: getDirection() }}>
    <div
      className="
        md:px-5 md:py-6
        H5:pb-4 H5:h-full H5:overflow-y-auto
        min-h-[600px] max-w-7xl mx-auto no_scrollbar relative bg-[#F5F6FA]
      "
      id="ShopContainer"
    >
      {/* 门店信息 */}
      <div style={{ paddingTop: `${top}px` }}>
        <ShopInfo container="ShopContainer" />
      </div>

      {/* 全部跳转卡片 */}
      {
        // 运营工具：门店、评价、健康度、下载 都没权限则不展示
        hasPermissionBatch([
          'PARTNER_SHOP_INFO',
          'PARTNER_CUSTOMER_EVALUATE',
          'PARTNER_BIZ_DATA_HEALTHY',
          'PARTNER_BIZ_DATA_DOWNLOAD',
        ], 'some')
          ? <div className={'flex flex-col'}>
            <div className={'px-3'}>
              <div className="px-[6px] text-gray mt-4 mb-[6px]">{t('bapp_ot_title')}</div>
            </div>
            <div className={`${styles.halfWidthCardwrap} flex mb-[6px] text-sm`} style={{ padding: '0 6px' }}>
              {
                [
                  {
                    isShow: hasBRbacPermission('PARTNER_SHOP_INFO'),
                    onClickHandler: handleToShopSetting,
                    iconName: restaurant,
                    content: t('B_APP_Basic_FirstPage_store_settings'), // 门店设置
                  },
                  {
                    isShow: hasBRbacPermission('PARTNER_CUSTOMER_EVALUATE'),
                    onClickHandler: handleToCustomerReview,
                    iconName: customer,
                    content: t('B_APP_Basic_FirstPage_customer_evaluation'), // 用户评价
                  },
                  {
                    isShow: isHealthShow && hasBRbacPermission('PARTNER_BIZ_DATA_HEALTHY'),
                    onClickHandler: handleToRestaurant,
                    iconName: golden,
                    content: t('healthscore_homepage_title'), // 健康度
                  },
                  {
                    isShow: hasBRbacPermission('PARTNER_BIZ_DATA_DOWNLOAD'),
                    onClickHandler: handleToDownload,
                    iconName: download,
                    content: t('bapp_ot_rd'), // 数据下载
                  },
                ].map((cardProps) => halfWidthCard(cardProps))
              }
            </div>
          </div> : null
      }

      {/* 全部跳转卡片 */}
      <div className="px-3 text-sm pb-9">
        {/* 广告 */}
        {hasBRbacPermission('PARTNER_ADVERTIVEMENT') ? <EntryInMoreTab /> : null}

        {
          // 帮助与支持： 商家大学、帮助中心、商家商城、支援热线 都没权限则不展示
          hasPermissionBatch([
            'PARTNER_MERCHANT_COLLEGE',
            'PARTNER_HELP_CENTER',
            'PARTNER_MERCHANT_MALL',
            'PARTNER_HELP_PHONE',
          ], 'some') ? <div className="px-[6px] text-gray mt-5 mb-3">{t('bapp_ot_hs')}</div> : null
        }
        <div className="rounded-lg bg-white pl-3 pr-[14px]">
          {
            [
              {
                isShow: hasBRbacPermission('PARTNER_MERCHANT_COLLEGE'),
                // isShow: hasBRbacPermission(''),
                onClickHandler: handleToUniversity,
                iconName: 'icon-university',
                content: t('bapp_ot_kt'), // 商家大学
              },
              {
                isShow: hasBRbacPermission('PARTNER_HELP_CENTER'),
                // isShow: hasBRbacPermission(''),
                onClickHandler: handleToHelpCenter,
                iconName: 'icon-helpcenter',
                content: t('setting_drawer_help_center'), // 帮助中心
              },
              // {
              //   // isShow: hasBRbacPermission('PARTNER_HELP_CENTER'),
              //   isShow: hasBRbacPermission(''),
              //   onClickHandler: handleToHelpCenter,
              //   iconName: 'icon-customerservice',
              //   content: t('bapp_ot_cs'), // 客服
              // },
              {
                isShow: showMerchantMall,
                // isShow: hasBRbacPermission(''),
                onClickHandler: handleToDeliveryMall,
                iconName: 'icon-marchantmall',
                content: t('delivery_mall'), // 商家商城
              },
              {
                isShow: showHotLine, // 兼容GCC新国逻辑
                // isShow: hasBRbacPermission(''),
                onClickHandler: handleToHotline,
                iconName: 'icon-dianhua',
                content: tnb('hotline_title'), // 支援热线
              },
            ].map((cardProps) => fullWidthArrowCard(cardProps))
          }
        </div>
      </div>

      {/* 添加底部阴影 */}
      <div className="fixed bottom-0 b-shadow w-full"></div>
    </div>
  </ConfigProvider>
  )
}

export default More